<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="审批编号：" prop="id">
            <el-input v-model="query.id" placeholder="请输入审批编号" size="small" clearable />
          </el-form-item>
          <el-form-item label="申请人信息：" prop="applyInfo">
            <el-input v-model="query.applyInfo" placeholder="请输入姓名/手机号" size="small" clearable />
          </el-form-item>
          <!-- <el-form-item label="申请人身份：">
            <el-select v-model="query.deptId" placeholder="请选择" clearable size="small">
              <el-option :label="item.value" :value="item.key" v-for="item in sectionList" :key="item.key"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="客户信息：" prop="customerInfo">
            <el-input v-model="query.customerInfo" placeholder="请输入姓名/手机号" size="small" clearable />
          </el-form-item>
          <el-form-item label="客户身份：">
            <el-select v-model="query.customerLevel" placeholder="请选择" clearable size="small">
              <el-option :label="item.name" :value="item.level" v-for="item in standingList" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="提交申请类型：">
            <el-select v-model="query.submitApplyType" placeholder="请选择" clearable size="small">
              <el-option label="自己提交" :value="1"></el-option>
              <el-option label="业务员提交" :value="2"></el-option>
              <el-option label="后台提交" :value="3"></el-option>
              <el-option label="主账号提交" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="门店类型：">
            <el-select v-model="query.shopType" placeholder="请选择" clearable size="small">
              <el-option :label="item" :value="item" v-for="(item,index) in companyOption" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="企业全称：" prop="companyName">
            <el-input v-model="query.companyName" placeholder="请输入企业称呼" size="small" clearable />
          </el-form-item>
          <el-form-item label="资质证件类：">
            <el-select v-model="query.companyZiZhi" placeholder="请选择" clearable size="small">
              <el-option label="医疗机构职业许可证" :value="2"></el-option>
              <el-option label="营业执照" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间筛选：">
            <el-select v-model="query.searchTimeType" placeholder="请选择" clearable size="small">
              <el-option label="提交时间" :value="1"></el-option>
              <el-option label="同意时间" :value="2"></el-option>
              <el-option label="驳回时间" :value="3"></el-option>
            </el-select>
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="doQueryList({pageNo:1})">
          <el-tab-pane label="待审核" name="0"></el-tab-pane>
          <el-tab-pane label="同意申请" name="1"></el-tab-pane>
          <el-tab-pane label="驳回申请" name="-1"></el-tab-pane>
        </el-tabs>
        <div class="btn-box">
          <!-- <el-button type="primary" size="mini" @click="handleDownload" plain>导出</el-button> -->
          <el-dropdown @command="handleUpdate" v-if="activeName=='0'" v-hasPermi="['finance:auth:examine']">
            <el-button type="primary" size="mini">批量操作<i class="el-icon--right el-icon-arrow-down"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="beforeHandleCommand(3)">批量同意</el-dropdown-item>
              <el-dropdown-item :command="beforeHandleCommand(4)">批量驳回</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">添加客户</el-button> -->
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" :key="activeName">
        <el-table-column type="selection" width="50" />
        <el-table-column label="审批编号" prop="id" align="center" fixed>
          <template slot-scope="{row}">
            <div @click="handleShowDetail(row.id)">
              <el-link type="primary">{{row.id}}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="申请人信息" prop="applyPho" align="" fixed width="200">
          <template slot-scope="{row}">
            <div>{{row.applyName}}</div>
            <div>{{row.applyPho}}</div>
          </template>
        </el-table-column>
        <el-table-column label="申请人身份" prop="applyLevelName" align="center" width="120">
        </el-table-column>
        <el-table-column label="提交申请类型" prop="" align="center" width="140">
          <template slot-scope="{row}">
            {{getSubmitApplyTypeName(row.submitApplyType)}}
          </template>
        </el-table-column>
        <el-table-column label="客户信息" prop="userPho" align="" width="200">
          <template slot-scope="{row}">
            <div>{{row.customerName}}</div>
            <div>{{row.customerPho}}</div>
          </template>
        </el-table-column>
        <el-table-column label="客户身份" prop="customerLevelName" align="center" />
        <el-table-column label="认证类型" prop="" align="center">
          <template slot-scope="{row}" >
            <span v-if="activeName=='0' || activeName=='-1'">{{row.waitCertificatesType==1?'企业认证':'个人认证'}}</span>
            <span v-else>{{row.certificatesType==1?'企业认证':'个人认证'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="门店类型" prop="" align="center" >
          <template slot-scope="{row}">
            {{getCompanyTypeName(row.waitCertificatesType?row.waitCertificatesType:row.certificatesType)}}
          </template>
        </el-table-column>
        <el-table-column label="企业全称/姓名" align="center" width="140">
          <template slot-scope="{row}">
            {{activeName=='0' || activeName=='-1'?row.waitCompanyName:row.companyName}}
          </template>
        </el-table-column>
        <el-table-column label="资质证件类型" prop="" align="center" width="140">
          <template slot-scope="{row}">
            <span v-if="activeName=='0' || activeName=='-1'">{{row.waitCompanyZiZhi==1?'营业执照':row.waitCompanyZiZhi==2?'医疗机构职业许可证':'身份证'}}</span>
            <span v-else>{{row.companyZiZhi==1?'营业执照':row.companyZiZhi==2?'医疗机构职业许可证':'身份证'}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="身份证号" prop="code" align="center" width="140">
          <template slot-scope="{row}" v-if="row.companyZiZhi==3">
            {{activeName=='0' || activeName=='-1'?row.waitCode:row.code}}
          </template>
        </el-table-column> -->
        <el-table-column label="证件凭证" prop="" align="center" width="200">
          <template slot-scope="{row}" v-if="row.certificatesImg || row.waitCertificatesImg">
            <div style="display: flex;justify-content: center;" v-if="(activeName=='0'  || activeName=='-1')&&row.waitCertificatesImg">
                <el-image style="width: 60px; height: 50px;margin-right: 4px;" :src="item" :preview-src-list="[item]" v-for="(item,index) in row.waitCertificatesImg.split(',')" :key="index"></el-image>
            </div>
            <div style="display: flex;justify-content: center;" v-if="activeName=='1'&&row.certificatesImg">
              <el-image style="width: 60px; height: 50px;margin-right: 4px;" :src="item" :preview-src-list="[item]" v-for="(item,index) in row.certificatesImg.split(',')" :key="index"></el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="统一社会信用代码/身份证" prop="code" align="center" width="180">
          <template slot-scope="{row}" v-if="row.companyZiZhi!=3 || row.waitCompanyZiZhi!=3">
            {{activeName=='0' || activeName=='-1'?row.waitCode:row.code}}
          </template>
        </el-table-column>
        <!-- <el-table-column label="纳税人识别号" prop="taxpayerCode" align="center" width="150">
          <template slot-scope="{row}">
            {{activeName=='0' || activeName=='-1'?row.waitTaxpayerCode:row.taxpayerCode}}
          </template>
        </el-table-column> -->
        <el-table-column label="提交时间" prop="operatedTime" sortable align="center" width="200" />
        <el-table-column label="同意时间" prop="auditTime" sortable align="center" width="200" v-if="activeName=='1'">
          <template slot-scope="{row}">
            {{row.auditTime}}
          </template>
        </el-table-column>
        <el-table-column label="审核备注" prop="auditRemark"  align="center" v-if="activeName =='1'" />
        <el-table-column label="审核上传图片" prop="" align="center" width="200" v-if="activeName =='1'">
          <template slot-scope="{row}" v-if="row.auditUrl">
            <div style="display: flex;justify-content: center;" v-if="row.auditUrl">
                <el-image style="width: 60px; height: 50px;margin-right: 4px;" :src="item" :preview-src-list="[item]" v-for="(item,index) in row.auditUrl.split(',')" :key="index"></el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="驳回时间" prop="auditTime" sortable align="center" width="200" v-if="activeName=='-1'" />
        <el-table-column label="驳回原因" prop="rejectCause" align="center" v-if="activeName=='-1'" width="200">
          <template slot-scope="{row}">
            {{row.rejectCause}}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right"  width="120" v-if="activeName=='0'">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate({type:1,row})" v-hasPermi="['finance:auth:examine']">同意</el-button>
            <el-button type="text" @click="handleUpdate({type:2,row})" v-hasPermi="['finance:auth:examine']">驳回</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize"
        @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <!-- <city-add ref="cityAdd" @created="doQueryList({})" :sectionList="sectionList" :popType="popType" /> -->
    <examine ref="examine" @created="doQueryList({})"  />
  </div>
</template>

<script>
  import cityCompanyApi from '@/api/sys/cityCompany'
  import sysDeptApi from '@/api/sys/sysDept'
  import Pagination from '@/components/Pagination'
  import custApi from '@/api/cust'
  // import cityAdd from './add'
  import customerLevelApi from '@/api/sys/customerLevel'
  import sysDataconstantApi from '@/api/config/sysDataconstant'
  import examine from './examine'
  export default {
    components: {
      Pagination,
      examine
    },
    data() {
      return {
        popType: null,
        list: [],
        total: 0,
        listLoading: true,
        query: {
          pageNo: 1,
          pageSize: 10,
        },
        sectionList: [],
        dateTime: null,
        activeName: '0',
        selectItems: [],
        standingList:[],
        companyOption:[]
      }
    },
    created() {
      this.doQueryList({
        pageNo: 1
      })
      this.getStandingList()
      this.getConfig()
    },
    methods: {
      // 获取系统配置
      getConfig() {
        sysDataconstantApi.fetchBatchCode({
          code: 'shopType'
        }).then(({
          data
        }) => {
          this.companyOption = data.list[0].content.split(',')
          // this.configList=data.list
          // console.log("配置: ",data);
        })
      },
      // 提交申请类型转换为中文名称
      getSubmitApplyTypeName(submitApplyType) {
        const submitApplyTypeMap = {
          1: '自己提交',
          2: '业务员提交',
          3: '后台提交',
          4: '主账号提交'
        }
        return submitApplyTypeMap[submitApplyType] || ''
      },
        // 将门店类型数字转换为中文名称
    getCompanyTypeName(companyType) {
      const companyTypeMap = {
        0: '诊所',
        1: '私立医院',
        2: '卫生室',
        3: '单体店',
        4: '社区卫生服务站',
        5: '美容院'
      }
      // 如果传入的是字符串（非数字），直接返回；如果是数字，返回对应中文名称；否则返回原值
      if (typeof companyType === 'string' && isNaN(companyType)) {
        return companyType
      }
      const num = Number(companyType)
      return companyTypeMap[num] !== undefined ? companyTypeMap[num] : companyType
    },
      // 获取客户身份
      getStandingList(){
        customerLevelApi.fetchList({type:3}).then(({data})=>{
          this.standingList=data
          console.log('客户身份: ',data);
        })
      },
      beforeHandleCommand(type) {
        return {
          'type': type
        }
      },
      handleUpdate({
        type,
        row
      }) {
        console.log('type: ', type);
        let ids=''
        if ([3, 4].includes(type)) {
          if(this.selectItems.length <= 0){
            this.$common.showMsg('warning', '请选择')
            return
          }
          ids = this.selectItems.map(row => row.id).join(',')
        }else{
          if(!row){
            this.$common.showMsg('warning', '数据错误')
            return
          }
          ids=row.id
        }
        let query={
          idStr:ids
        }
        if ([2, 4].includes(type)) {
          this.$prompt(type == 4 ? `当前选择${this.selectItems.length}条数据,是否确认驳回申请` : '是否确认驳回申请', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              inputPlaceholder: '请输入驳回原因',
            }).then(({
              value
            }) => {
              query.remark=value
              // console.log('query11: ',query);
              // return
              custApi.rejectApply(query).then((res)=>{
                this.$message.success('操作成功')
                this.doQueryList({ pageNo: 1 })
              })
            })
            .then(() => {
              this.doQueryList({
                pageNo: 1
              })
            })
        }
        if([1, 3].includes(type)){
          if(type == 1) return this.$refs.examine.handleUpdate(row)
          this.$common.confirm(type==1?'是否确认同意申请':`当前选择${this.selectItems.length}条数据,是否确认同意申请`).then(() => {
            custApi.agreeApply(query).then((res)=>{
              this.$message.success('操作成功')
              this.doQueryList({ pageNo: 1 })
            })
          })
            .then(() => {
              this.doQueryList({ pageNo: 1 })
            })
        }
      },
      /**
       * 选择框变化
       */
      selectionChange(val) {
        this.selectItems = val
      },
      handleFilter() {
        this.dateTime=null
        this.query = {
          pageNo: 1,
          pageSize: 10,
        }
        this.doQueryList({
          pageNo: 1
        })
      },
      // 获取部门
      getOption() {
        sysDeptApi.findOptions().then(({
          data
        }) => {
          this.sectionList = data
        })
      },
      /**
       * 触发搜索操作
       */
      handleQuery() {
        this.doQueryList({
          pageNo: 1
        })
      },
      /**
       * 执行列表查询
       */
      doQueryList({
        pageNo,
        pageSize
      }) {
        if (pageNo) {
          this.query.pageNo = pageNo
        }
        if (pageSize) {
          this.query.pageSize = pageSize
        }
        // this.query.auditStatus = this.activeName
        let query = {
          ...this.query,
        }
        query.auditStatus=this.activeName
        if([1,2,3].includes(this.query.searchTimeType) && this.dateTime){
          query.timeStart=this.dateTime[0]
          query.timeEnd=this.dateTime[1]
        }
        this.listLoading = true
        return custApi.fetchList(query)
          .then(({
            data
          }) => {
            // console.log("data: 列表", data);
            this.list = data.list
            this.total = data.total
          })
          .finally(() => {
            this.listLoading = false
          })
      },
      /**
       * 打开新建、编辑表单
       */
      // handleCreate(type,row) {
      //   this.popType=type
      //   if(!type){
      //     this.$refs.cityAdd.handleCreate()
      //   }else{
      //     this.$refs.cityAdd.handleUpdate(row)
      //   }
      // },
      //查看信息
      handleShowDetail(id) {
        this.$emit('handleShow', id, 2)
      },
    }
  }
</script>
